// extracted by mini-css-extract-plugin
module.exports = {"mdBreakPoint":"992","logo":"_2rQ42i8NT8nDNUNe","logoText":"_2iHJm0rEKcNntoK9"};